import { Button, Card, Col, Form, Icon, Row, TextInput } from 'ui';

export type SharedEventEnterFormValues = {
  email: string;
  firstName: string;
  lastName: string;
};

type P = {
  initialValues: Partial<SharedEventEnterFormValues>;
  loading: boolean;
  onFinish: (values: SharedEventEnterFormValues) => void;
};

const SharedEventEnterFormCard = ({ initialValues, loading, onFinish }: P) => {
  const [form] = Form.useForm<SharedEventEnterFormValues>();

  return (
    <Card>
      <Form<SharedEventEnterFormValues> form={form} initialValues={initialValues} onFinish={onFinish}>
        <Row gutter={['ms', 0]}>
          <Col span={12}>
            <TextInput
              item={{
                label: 'First name',
                name: 'firstName',
                rules: [
                  {
                    required: true,
                    whitespace: true,
                  },
                ],
              }}
            />
          </Col>
          <Col span={12}>
            <TextInput
              item={{
                label: 'Last name',
                name: 'lastName',
                rules: [
                  {
                    required: true,
                    whitespace: true,
                  },
                ],
              }}
            />
          </Col>
          <Col span={24}>
            <TextInput
              item={{
                label: 'Email',
                name: 'email',
                rules: [
                  {
                    required: true,
                    type: 'email',
                  },
                ],
              }}
            />
          </Col>
          <Col span={24}>
            <Button block htmlType="submit" icon={<Icon icon="camcorder-line" />} loading={loading} type="primary">
              Join live
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default SharedEventEnterFormCard;
